import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_warning_rules",
  ref: "addStoresModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_merchant_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_add_store_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_add_store_header",
  "data-kt-scroll-wrappers": "#kt_modal_add_store_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_10 = { class: "row mb-7" }
const _hoisted_11 = { class: "col-md-6 form-group" }
const _hoisted_12 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_13 = { class: "col-md-6 form-group" }
const _hoisted_14 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_15 = { class: "row mb-7" }
const _hoisted_16 = { class: "col-md-6 form-group" }
const _hoisted_17 = { class: "col-md-6 form-group" }
const _hoisted_18 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_19 = { class: "row mb-7" }
const _hoisted_20 = { class: "col-md-6 form-group" }
const _hoisted_21 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("€")
const _hoisted_23 = { class: "col-md-6 form-group" }
const _hoisted_24 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_25 = { class: "row mb-7" }
const _hoisted_26 = { class: "col-md-12 form-group" }
const _hoisted_27 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_28 = { class: "row mb-7" }
const _hoisted_29 = { class: "col-md-6 form-group" }
const _hoisted_30 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_31 = { class: "row mb-7" }
const _hoisted_32 = { class: "col-md-12 form-group" }
const _hoisted_33 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_34 = { class: "modal-footer flex-center" }
const _hoisted_35 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_36 = {
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_37 = { class: "indicator-label" }
const _hoisted_38 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_39 = { class: "indicator-progress" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_editor = _resolveComponent("editor")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("common.add") + _ctx.t("common.monitoringRules")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("warningRules.category")), 1),
                    _createVNode(_component_el_form_item, { prop: "category" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.category,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.category) = $event)),
                          clearable: "",
                          filterable: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          style: {"width":"100%"},
                          onChange: _ctx.handleCategory
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.category, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("warningRules.levelOptions")), 1),
                    _createVNode(_component_el_form_item, { prop: "cargo_damage_level" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.cargo_damage_level,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.cargo_damage_level) = $event)),
                          clearable: "",
                          filterable: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCargoDamageLevel, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["fs-6 fw-bold mb-2", _ctx.formData.category == '1' ? 'required' : ''])
                    }, _toDisplayString(_ctx.t("warningRules.maximumExtensionDays")), 3),
                    _createVNode(_component_el_form_item, { prop: "maximum_extension_days" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.maximum_extension_days,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.maximum_extension_days) = $event)),
                          type: "text",
                          placeholder: _ctx.t('common.plsEnter'),
                          clearable: ""
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("warningRules.fulfillmentType")), 1),
                    _createVNode(_component_el_form_item, { prop: "fulfillment_type" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.formData.fulfillment_type,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.fulfillment_type) = $event)),
                          clearable: "",
                          placeholder: _ctx.t('common.plsSelect')
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.fulfillment_type, (group) => {
                              return (_openBlock(), _createBlock(_component_el_option_group, {
                                key: group.label,
                                label: group.label
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.children, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.t("warningRules.liquidatedDamages")), 1),
                    _createVNode(_component_el_form_item, { prop: "liquidated_damages" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.liquidated_damages,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.liquidated_damages) = $event)),
                          type: "number",
                          placeholder: _ctx.t('common.plsEnter'),
                          clearable: ""
                        }, {
                          prepend: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("warningRules.processingMethod")), 1),
                    _createVNode(_component_el_form_item, { prop: "processing_method" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.processing_method,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.processing_method) = $event)),
                          type: "text",
                          placeholder: _ctx.t('common.plsEnter'),
                          clearable: ""
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.t("warningRules.referenceScheme")), 1),
                    _createVNode(_component_el_form_item, { prop: "reference_scheme" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_editor, {
                          modelValue: _ctx.formData.reference_scheme,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.reference_scheme) = $event)),
                          id: "scriptEditorReferenceScheme",
                          "api-key": "um8hddq76emgau1ymqr7w6320mhxcygdf5qy8ep56zrl0s9f",
                          init: {
                        height: 300,
                        menubar: false,
                        plugins: [
                          'advlist autolink lists link image charmap print preview anchor',
                          'searchreplace visualblocks code fullscreen',
                          'insertdatetime media table paste code help wordcount',
                        ],
                        toolbar:
                          'undo redo | formatselect | bold italic backcolor forecolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent Underline | link | mceInsertLink | removeformat | help',
                      }
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("warningRules.alarmMode")), 1),
                    _createVNode(_component_el_form_item, { prop: "alarm_mode" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.alarm_mode,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.alarm_mode) = $event)),
                          clearable: "",
                          filterable: "",
                          multiple: "",
                          placeholder: _ctx.t('common.plsSelect'),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.alarm_mode, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.t("warningRules.alarmContent")), 1),
                    _createVNode(_component_el_form_item, { prop: "alarm_content" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_editor, {
                          modelValue: _ctx.formData.alarm_content,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.alarm_content) = $event)),
                          id: "scriptEditorAlarmContent",
                          "api-key": "um8hddq76emgau1ymqr7w6320mhxcygdf5qy8ep56zrl0s9f",
                          init: {
                        height: 300,
                        menubar: false,
                        plugins: [
                          'advlist autolink lists link image charmap print preview anchor',
                          'searchreplace visualblocks code fullscreen',
                          'insertdatetime media table paste code help wordcount',
                        ],
                        toolbar:
                          'undo redo | formatselect | bold italic backcolor forecolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent Underline | link | mceInsertLink | removeformat | help',
                      }
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-light me-3",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
              }, [
                _createElementVNode("span", _hoisted_35, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.discard")), 1)
              ]),
              _createElementVNode("button", _hoisted_36, [
                _createElementVNode("span", _hoisted_37, [
                  _createElementVNode("span", _hoisted_38, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                ]),
                _createElementVNode("span", _hoisted_39, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_40
                ])
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}